import React, { Component } from "react";

class GoogleMap extends Component {
  render() {
    return (
      <div className="contact-bottom">
        <div className="contac-bottom">
          <div className="row justify-content-center g-0">
            <div className="col-12">
              <div className="location-map">
                <div id="map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.4277561042372!2d7.420814073404184!3d9.115779890949046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104ddf0025d2274f%3A0x7506eaacdfe863ee!2sSyrol%20Technologies%20Ltd!5e0!3m2!1sen!2sng!4v1734422838292!5m2!1sen!2sng"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleMap;
